var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({attrs:{"value":_vm.value,"items":_vm.sortedItems,"loading":_vm.loading},on:{"focus":function () { return _vm.focusHandler(); }}},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }